// src/pages/previewArticle/PreviewArticle.jsx
import React, { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Context } from "../../context/Context";
import Post from "../post/Post";
import { Helmet } from "react-helmet";

export default function PreviewArticle() {
  const { postSlug } = useParams();
  const slug = postSlug;
  const { token } = useContext(Context);
  const [post, setPost] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const { data } = await axios.get(`/posts/slug/${slug}?includeDrafts=true`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (mounted) setPost(data);
      } catch (e) {
        if (mounted) setErr(e?.response?.data?.message || "Failed to load preview.");
      }
    })();
    return () => { mounted = false; };
  }, [slug, token]);

  if (err) return <div style={{ padding: 24 }}>Preview error: {err}</div>;
  if (!post) return <div style={{ padding: 24 }}>Loading preview…</div>;

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex,nofollow" />
        <title>Preview • {post.seoTitle || post.title}</title>
      </Helmet>

      {/* Optional banner so reviewers know it’s a draft */}
      {post.status === "draft" && (
        <div style={{ background: "#fff3cd", padding: "8px 16px", borderBottom: "1px solid #ffe69c" }}>
          Preview of <strong>Draft</strong> • Last saved: {new Date(post.updatedAt || post.createdAt).toLocaleString()}
        </div>
      )}

      <Post post={post} isPreview />
    </>
  );
}
